/**
 * サンプルクラス
 * @constructor
 */
class TopWorksSlide {

  constructor() {
    this._addClassNameVal = 'is-active';
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-topParallax）が存在する場合、トップパララックスを実行する
  */
  init() {
    if (document.querySelector('.js-topWorksSlider')) {
      this.topWorksSwiperSlider();
    }
  }
  topWorksSwiperSlider() {
    const slides = document.querySelectorAll('.p-topWorks__slideItem');
    const addClassNameVal = this._addClassNameVal;
    let currentSlide = 0;

    function showSlide(slideIndex) {
      slides.forEach((slide, index) => {
        if (index === slideIndex) {
          slide.style.opacity = 1;
          slide.classList.add(addClassNameVal);
        } else {
          slide.style.opacity = 0;
          slide.classList.remove(addClassNameVal);
        }
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }
    // 初期表示
    showSlide(currentSlide);

    // 2.5秒ごとに次のスライドを表示
    setInterval(nextSlide, 2500);
  }
}

export default TopWorksSlide;
